import register from '../util/register'
import angular from 'angular'
import SearchFormController from './SearchFormController'
import SearchParametersService from './SearchParametersService'
import AddAlertModalController from './AddAlertModalController'
import MultipleValuesModalController from './MultipleValuesModalController'
import MultipleValuesService from './MultipleValuesService'
import ProperCase from './ProperCase.directive'
import '../records/records.module'

var searchForm = angular.module(
  'app.searchForm',
  [
    'app.records',
    'ui.bootstrap',
    'ui.bootstrap.alert',
    'ui.bootstrap.datepicker',
    'ui.bootstrap.typeahead',
    'app.searchResults',
    'angularjs-dropdown-multiselect'
  ]
)

register('app.searchForm')
  .controller('SearchFormController', SearchFormController)
  .controller('AddAlertModalController', AddAlertModalController)
  .controller('MultipleValuesModalController', MultipleValuesModalController)
  .service('SearchParametersService', SearchParametersService)
  .service('MultipleValuesService', MultipleValuesService)
  .directive('properCase', ProperCase)

searchForm.run()
